import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// API pÃºblica (sin token de auth, para acceso externo por token de formulario)
const publicApi = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor para agregar token a cada solicitud
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config; 
});

// Interceptor de respuesta: si el backend devuelve 401, limpiar sesión y redirigir
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  },
);

// Servicio de AutenticaciÃ³n
export const authService = {
  register: (data) => api.post("/auth/register", data),
  login: (email, password) => api.post("/auth/login", { email, password }),
  getCurrentUser: () => api.get("/auth/me"),
  logout: () => api.post("/auth/logout"),
};

// Servicio de PadrÃ³n
export const padronService = {
  getPadronByDni: (dni) => api.get(`/padrones/${dni}`),
  getAllPadrones: (page = 1, limit = 10, search = "") =>
    api.get("/padrones", { params: { page, limit, search } }),
  createPadron: (data) => api.post("/padrones", data),
};

// Servicio de Cargas de Formularios
export const formSubmissionService = {
  // Flujo antiguo (submit directo)
  submitFormWithFiles: (formData) =>
    api.post("/submissions/submit", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),

  // Nuevo flujo: referente genera link (sin DNI - el solicitante lo ingresa)
  generateFormLink: () => api.post("/submissions/generate-link"),

  // Eliminar link vacio (solo submissions pendiente_solicitante)
  deleteEmptyLink: (submissionId) => api.delete(`/submissions/${submissionId}`),

  // Revision del referente
  referenteReview: (submissionId, action, correctionNote = "") =>
    api.put(`/submissions/${submissionId}/referente-review`, {
      action,
      correctionNote,
    }),

  // Secretaria actualiza datos del servicio
  updateServiceData: (submissionId, data) =>
    api.put(`/submissions/${submissionId}/service-data`, data),

  getSubmissionById: (submissionId) => api.get(`/submissions/${submissionId}`),
  getMySubmissions: (page = 1, limit = 10) =>
    api.get("/submissions/my-submissions", { params: { page, limit } }),
  getAllSubmissions: (page = 1, limit = 10, status = "", search = "") =>
    api.get("/submissions/all", { params: { page, limit, status, search } }),
  updateSubmissionStatus: (submissionId, status, rejectionReason = "") =>
    api.put(`/submissions/${submissionId}/status`, { status, rejectionReason }),
};

// Servicio publico para solicitante externo (sin auth)
export const publicFormService = {
  getFormByToken: (token) => publicApi.get(`/submissions/form/${token}`),
  submitFormByToken: (token, formData) =>
    publicApi.post(`/submissions/form/${token}`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    }),
  validatePadron: (dni) =>
    publicApi.get(
      `/submissions/public/validate-padron/${encodeURIComponent(dni)}`,
    ),
};

// Servicio de Usuarios
export const userService = {
  getAllUsers: (page = 1, limit = 10, search = "") =>
    api.get("/users", { params: { page, limit, search } }),
  getUserById: (userId) => api.get(`/users/${userId}`),
  // Crear referente o secretaria (solo secretaria)
  createManagedUser: (data) => api.post("/users/create-managed", data),
  createReferente: (data) => api.post("/users/create-referente", data),
  updateUser: (userId, data) => api.put(`/users/${userId}`, data),
  deleteUser: (userId) => api.delete(`/users/${userId}`),
};

export default api;
